class BespokeForm extends HTMLElement {
  constructor() {
    super();

    this.activeSectionIndex = 0;
    this.container = this.querySelector('.bespoke-form-sections');
    this.sections = this.querySelectorAll('.bespoke-form__section');
    this.totalSections = this.sections.length - 1;
    this.activeSection = this.querySelector('.bespoke-form__section.is-active');
    this.continueButtons = this.querySelectorAll('.bespoke-form__continue-button');
    this.backButtons = this.querySelectorAll('.bespoke-form__back-button');
    this.navItems = this.querySelectorAll('.bespoke-form__nav-item');
    this.options = this.querySelectorAll('.bespoke-form__option, .bespoke-form__pic-option, .bespoke-form__swatch-option')
    this.textInputField = this.querySelectorAll('.text-input');
    this.selectedMultiSelectOptions = new Map();
    this.form = this.querySelector('#contact_form');
    this.submitButton = this.querySelector('#submit-button');
    this.errorContainer = this.querySelector('#errorMessages')

    const params = new URLSearchParams(window.location.search);

    if (params.get("contact_posted") === "true") {
      const parent = this.closest('.bespoke-service-template');

      if (parent) {
        parent.classList.add('form-success');
      }
    }

    this.eventhandlers();
    this.setActiveSection(0);
  }

  eventhandlers() {
    this.continueButtons.forEach(button => {
      button.addEventListener('click', () => this.setActiveSection(this.activeSectionIndex + 1));
    });

    this.backButtons.forEach(button => {
      button.addEventListener('click', () => this.setActiveSection(this.activeSectionIndex - 1));
    });

    this.options.forEach(button => {
      button.addEventListener('click', (event) => {
        const dataId = button.dataset.inputId;
        const dataValue = button.dataset.value;
        const parent = button.closest('.options-group');

        if (parent) {
          if (parent.getAttribute('role') === 'radiogroup') {
            const activeOption = parent.querySelectorAll('.bespoke-form__option.is-active, .bespoke-form__pic-option.is-active, .bespoke-form__swatch-option.is-active');
            // Remove active class from previous active items
            activeOption.forEach(option => option.classList.remove('is-active'));
            // Set active class on current
            button.classList.add('is-active');
            // Set active class on radio group element
            parent.classList.add('option-selected');

            if (dataValue && dataId) {
              const hiddenInput = this.querySelector(`#${dataId}`);

              if (hiddenInput) {
                hiddenInput.value = dataValue;
              }
            }

            if (!parent.classList.contains('option-selected')) {
              parent.classList.add('option-selected');
            }
          } else if (parent.getAttribute('role') === 'listbox') {
            const hiddenInput = this.querySelector(`#${dataId}`);

            if (!this.selectedMultiSelectOptions.has(dataId)) {
              this.selectedMultiSelectOptions.set(dataId, new Set());
            }
            const selections = this.selectedMultiSelectOptions.get(dataId);

            // Toggle selection
            if (selections.has(dataValue)) {
              selections.delete(dataValue);
              button.classList.remove('is-active');
            } else {
              selections.add(dataValue);
              button.classList.add('is-active');
            }

            // Update hidden field
            hiddenInput.value = Array.from(selections).join(", ");

            if (hiddenInput.value != "") {
              parent.classList.add('option-selected');
            } else {
              parent.classList.remove('option-selected');
            }
          }
        }
      });
    })

    this.textInputField.forEach(input => {
      input.addEventListener('input', (event) => {
        const dataId = event.target.name;
        const hiddenInput = this.querySelector(`#${dataId}`);

        if (hiddenInput) {
          hiddenInput.value = event.target.value;
        }
      });
    })

    // Handle budget select field
    const budgetSelect = this.querySelector('#ring-budget');
    if (budgetSelect) {
      budgetSelect.addEventListener('change', (event) => {
        const hiddenInput = this.querySelector('#bespokeFormBudget');
        if (hiddenInput) {
          hiddenInput.value = event.target.value;
        }
      });
    }

    // Handle budget select field
    const sourceSelect = this.querySelector('#referral-source');
    if (sourceSelect) {
      sourceSelect.addEventListener('change', (event) => {
        const hiddenInput = this.querySelector('#bespokeFormSource');
        if (hiddenInput) {
          hiddenInput.value = event.target.value;
        }
      });
    }

        // Handle newsletter opt-in checkbox
    const newsletterCheckbox = this.querySelector('#contactFormNewsletter');
    const newsletterHiddenInput = this.querySelector('#bespokeFormNewsletter');
    if (newsletterCheckbox && newsletterHiddenInput) {
      newsletterCheckbox.addEventListener('change', (event) => {
        newsletterHiddenInput.value = event.target.checked ? 'Yes' : 'No';
      });
    }
    
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent default form submission
      this.errorContainer.innerHTML = "";

      const firstName = this.form.querySelector("#contactFormFname").value.trim();
      const lastName = this.form.querySelector("#contactFormLname").value.trim();
      const email = this.form.querySelector("#contactFormEmail").value.trim();
      const phone = this.form.querySelector("#contactFormPhone").value.trim();

      let errors = [];

      // 2. LOGIC GATE CHECK (Hidden Fields)
      // Real humans must have selected a "Customer" type in Step 1
      const customerType = this.querySelector('#bespokeFormCustomer').value;
      if (!customerType) {
         // You can silently fail here, or show a generic error
         console.log("Bot detected: Logic steps skipped.");
         return; 
      }

      // Basic required field checks
      if (!firstName) errors.push("First name is required");
      if (firstName.length > 30) errors.push("First name is too long");

      if (!lastName) errors.push("Last name is required");
      if (lastName.length > 30) errors.push("Last name is too long");

      if (!phone) errors.push("A phone number is required");
      if (!email) {
        errors.push("Email is required");
      } else if (!this.validateEmail(email)) {
        errors.push("Please enter a valid email address");
      }

      if (errors.length > 0) {
        this.errorContainer.innerHTML = errors.join(", ");
        return; // stop submission
      }

      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData.entries());

      // If the honeypot field is in formData, delete it before sending to Zapier
      if (data["contact[confirm_email_address]"]) {
        delete data["contact[confirm_email_address]"];
      }
      // Newsletter opt-in -> Flodesk Zap. Fire-and-forget: never blocks the enquiry.
      if (data["contact[newsletter_signup]"] === "Yes") {
        fetch('https://hooks.zapier.com/hooks/catch/23428658/4hpjfbn/', {
          method: 'POST',
          body: JSON.stringify({
            email: data["contact[email]"],
            first_name: data["contact[first_name]"],
            last_name: data["contact[last_name]"],
            source: "Bespoke enquiry form",
            consent_given_at: new Date().toISOString()
          })
        }).catch(error => console.error('Newsletter opt-in failed:', error));
      }

      // Main enquiry -> Dubsado Zap. Do not change this URL.
      fetch('https://hooks.zapier.com/hooks/catch/23428658/ukzwki8/', {
        method: 'POST',
        body: JSON.stringify(data)
      })
      .then(response => {
        if (response.ok) {
          // Handle success (e.g., redirect to Thank You page)
          const parent = this.closest('.bespoke-service-template');

          if (parent) {
            parent.classList.add('form-success');
          }
        }
      })
      .catch(error => {
        console.error('Error:', error)
        this.form.submit();
      });
    })
  }

  // Simple email validation
  validateEmail(email) {
    // Basic pattern, can be improved
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  setActiveSection(index) {
    this.scrollToTop();
    const activeSection = this.sections[this.activeSectionIndex];

    if (index >= 0 && index <= this.totalSections) {
      this.activeSectionIndex = index;
      const nextActiveSection = this.sections[index]

      activeSection?.classList.remove('is-active');
      nextActiveSection?.classList.add('is-active');

      if (nextActiveSection) {
        this.setActiveTab(parseInt(nextActiveSection.dataset.tab));
        
        const newHeight = nextActiveSection.offsetHeight;

        // Apply height with px unit
        this.container.style.height = newHeight + "px";

        // Update Lenis after layout change
        // lenis?.resize();
        // lenis?.raf(performance.now());
      }
    }
  }

  setActiveTab(index) {
    const activeTab = this.navItems[index]
    Array.from(this.navItems).find(item => item.classList.contains('is-active'))?.classList.remove('is-active'); 
    activeTab.classList.add('is-active')
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('bespoke-form', BespokeForm);